module.exports = __webpack_public_path__ + "static/img/IMG_20160605_092744.6aa07378.jpg";